import React from "react";
import "../css/Footer2.css";

const Footer = () => {
  return (
    <footer className="footer2">

      {/* Brand Section */}
      <div className="footer2-brand">
        <h1 className="footer2-logo">FLEXOR</h1>
        <p className="footer2-tagline">Strength. Precision. Discipline.</p>
      </div>

      {/* Footer Navigation */}
      <div className="footer2-links">
        <a href="/">Home</a>
        <a href="/workout">Workout</a>
        <a href="/pricing">Pricing</a>
        <a href="/services">Services</a>
        <a href="/gallery">Gallery</a>
        <a href="/trainers">Trainers</a>
        <a href="/about">About</a>
        <a href="/contact">Contact</a>
        <a href="/faqs">FAQs</a>
      </div>

      {/* Social Icons */}
      <div className="footer2-socials">
        <a href="#"><i className="fa-brands fa-instagram"></i></a>
        <a href="#"><i className="fa-brands fa-facebook"></i></a>
        <a href="#"><i className="fa-brands fa-youtube"></i></a>
      </div>

      {/* Bottom Credits */}
      <div className="footer2-bottom">
        <p>© {new Date().getFullYear()} FLEXOR FITNESS. All Rights Reserved.</p>
      </div>

    </footer>
  );
};

export default Footer;
